<template>
    <div class="profile-update-container">
      <form @submit.prevent="submitProfileUpdate" class="profile-form">
        <div class="form-section">
          <h1>Mettre à jour le profil</h1>
          
          <div class="form-group">
            <label for="modifyEditUserName">Nom d'utilisateur</label>
            <input 
              v-model="username" 
              type="text" 
              id="modifyEditUserName" 
              placeholder="Nom d'utilisateur" 
              autocomplete="username" 
              :maxlength="getMaxLength('username')"
              :disabled="true"
            >
          </div>
          
          <div class="form-group">
            <label for="modifyeditEMail">Adresse e-mail</label>
            <input 
              v-model="email" 
              type="email" 
              id="modifyeditEMail" 
              placeholder="e-mail" 
              :maxlength="getMaxLength('email')"
              :disabled="true"
              >
          </div>
          
          <div class="form-group">
            <label for="modifyEditName">Nom</label>
            <input 
              v-model="name" 
              type="text" 
              id="modifyEditName" 
              placeholder="Nom" 
              :maxlength="getMaxLength('name')"
            >
          </div>
          
          <div class="form-group">
            <label for="modifyEditSurname">Prénom</label>
            <input 
              v-model="surname" 
              type="text" 
              id="modifyEditSurname" 
              placeholder="Prénom" 
              :maxlength="getMaxLength('name')"
            >
          </div>
          
          
          <div class="form-group">
            <label for="modifyEditAddress">Adresse</label>
            <input 
              v-model="address" 
              type="text" 
              id="modifyEditAddress" 
              placeholder="Adresse"
              :maxlength="getMaxLength('address')"
            >
          </div>
          
          <div class="form-group">
            <label for="modifyEditCompany">Entreprise</label>
            <input 
              v-model="company" 
              type="text" 
              id="modifyEditCompany" 
              placeholder="Entreprise" 
              :maxlength="getMaxLength('address')"
            >
          </div>
          
          <div class="form-group">
            <label for="modifyEditPhone">No de téléphone</label>
            <input 
              v-model="phone" 
              type="tel" 
              id="modifyEditPhone" 
              placeholder="No de téléphone"
              :maxlength="getMaxLength('phone')"
            >
          </div>
          
          <div class="form-group">
            <label for="modifyEditMobile">No de mobile</label>
            <input 
              v-model="mobile" 
              type="tel" 
              id="modifyEditMobile" 
              placeholder="No de mobile"
              :maxlength="getMaxLength('phone')"
            >
          </div>
          
          <!-- Password Change Section -->
           
      <!--     <div class="password-section">
            <h3>Modification du mot de passe (optionnel)</h3>
            
            
            <div class="form-group">
              <label for="modifyCurrentPassword">Mot de passe actuel</label>
              <input v-model="password" type="password" id="modifyCurrentPassword" placeholder="Mot de passe actuel" :maxlength="getMaxLength('password')">
            </div>
            <div class="form-group">
              <label for="modifyNewPassword">Nouveau mot de passe</label>
              <input v-model="modifyNewPassword" type="password" id="modifyNewPassword" placeholder="Nouveau mot de passe" :maxlength="getMaxLength('password')">
            </div>
            
            <div class="form-group">
              <label for="modifyConfirmNewPassword">Confirmez le nouveau mot de passe</label>
              <input v-model="modifyConfirmNewPassword" type="password" id="modifyConfirmNewPassword" placeholder="Confirmez le nouveau mot de passe" :maxlength="getMaxLength('password')">
            </div>
            
          </div> -->
          
          <div class="form-footer">
            <button type="submit">Enregistrer</button>
          </div>
        </div>
      </form>
    </div>
  </template>
  
  <script>
import { mapGetters, mapState } from 'vuex';
import '../../assets/styles/base.css';

export default {
  name: 'ProfileUpdateForm',
  data() {
    return {
      username: "",
      name: "",
      surname: "",
      email: "",
      confirmEmail: "",
      address: "",
      company: "",
      phone: "",
      mobile: "",
      showPassword: false
    };
  },
  computed: {
    ...mapState('referential', ['maxLength']),
    ...mapState('auth', ['user_id','userInfo']),
    ...mapGetters('referential', ['getMaxLength']),
  },
  mounted() {
    this.fetchUserData();
  },
  methods:{
    fetchUserData() {
      this.$store.dispatch('auth/fetchUserData')
        .then(user => {
          this.username = user.username;
          this.name = user.name;
          this.surname = user.surname;
          this.email = user.email;
          this.address = user.address;
          this.company = user.company;
          this.phone = user.phone;
          this.mobile = user.mobile;
        });
    },
    submitProfileUpdate() {
      const profileData = {
        name: this.name,
        surname: this.surname,
        address: this.address || '',
        company: this.company,
        phone: this.phone || '',
        mobile: this.mobile || '',
        /* username: this.username, */
        /* email: this.email, */
        /*password: this.modifyNewPassword || "",
        password: this.modifyConfirmNewPassword || "", */
      };
      this.$store.dispatch('auth/updateUserData', profileData)
        .then(() => {
          alert('Profile updated successfully!');
        })
        .catch(error => {
          console.error('Error updating profile:', error);
          alert('Failed to update profile. Please try again.');
        });
    }
  },
};
  </script>
  
  <style scoped>
  h1{
    font-size: 20px;
    margin-bottom: 20px;
    font-weight: bold;
    color: var(--primary-color);
  }
  .profile-update-container {
    max-width: 600px;
    margin: 0 auto;
    padding: 20px;
  }
  
  .form-group {
    margin-bottom: 15px;
  }
  
  .form-group label {
    display: block;
    margin-bottom: 5px;
  }
  
  .form-group input {
    width: 100%;
    padding: 8px;
    border: 1px solid #ddd;
    border-radius: 4px;
  }
  
  .form-footer {
    margin-top: 20px;
    text-align: right;
  }

  button:disabled {
    background-color: #cccccc;
    cursor: not-allowed;
  }
  </style>